export const topUpAccount = async (
    API_URL: string,
    token: string,
    employerId: string,
    employeeId: string,
    accountId: string,
    amount: number
) => {
    const response = await fetch(
        `${API_URL}/employers/${employerId}/employees/${employeeId}/accounts/${accountId}/top-ups`,
        {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              amount: amount
            })
        }
    )

    if (!response.ok) {
        throw new Error("There was a problem topping up this account.");
    }
}